import {
  CircularProgress,
  CircularProgressProps,
  createTheme,
  ThemeProvider,
} from "@mui/material";

interface ICDSpinner extends CircularProgressProps {}

export const CDSpinner = (props: ICDSpinner) => {
  const theme = createTheme({
    palette: {
      info: {
        main: "#00a0ff",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CircularProgress {...props}></CircularProgress>
    </ThemeProvider>
  );
};
